import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  button: {
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -40%)',
  },
}));

export type PBaseButtonProps = ButtonProps & {
  loading?: boolean;
};

export const BaseButton: React.FC<PBaseButtonProps> = (props) => {
  const {
    variant = 'contained',
    color = 'primary',
    loading,
    children,
    className,
    onClick,
    ...otherProps
  } = props;

  const classes = useStyles();
  return (
    <Button
      variant={variant}
      color={color}
      className={clsx(classes.button, className)}
      onClick={(e) => {
        if (!loading && onClick) {
          onClick(e);
        }
      }}
      {...otherProps}
    >
      {children}
      {loading && (
        <div className={classes.buttonProgress}>
          <CircularProgress size={24} style={{ color: '#c5c5c5' }} />
        </div>
      )}
    </Button>
  );
};
